export default __webpack_public_path__ + "static/form-button-feedback-do-d6e2495de3b8275d49c37cce23d7eb38fd8b8571363d10a94215ef25ae39c28b.png";